const generateForm06 = [
  {
    label: "คำนำหน้า (ภาษาอังกฤษ)",
    name: "title_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ชื่อ (ภาษาอังกฤษ)",
    name: "first_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "นามสกุล (ภาษาอังกฤษ)",
    name: "last_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ฉายา (ภาษาอังกฤษ)",
    name: "buddhist_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ข้อมูลการไปปฏิบัติงาน",
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },

  {
    label: "หน่วยงานที่ไปปฏิบัติงานให้",
    name: "organization",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 9 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ประเทศ",
    name: "country",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ตำแหน่งที่จะไปปฏิบัติงาน",
    name: "position",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ระดับ",
    name: "level",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 2 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "หน้าที่ที่จะไปปฏิบัติงาน (โดยย่อ)",
    name: "duties_performed",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 6 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },

  {
    label: "การติดต่อไปปฏิบัติงาน",
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "",
    name: "contact_name",
    placeholder: "placeholder",
    type: "radio-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "contact_work",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "contact_work",
  },

  {
    label: "ระยะเวลาที่จะขอไปปฏิบัติงาน",
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "จำนวนปี",
    name: "year_amount",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "period_time_work",
  },
  {
    label: "จำนวนเดือน",
    name: "month_amount",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "period_time_work",
  },
  {
    label: "จำนวนวัน",
    name: "day_amount",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "period_time_work",
  },
  {
    label: "กำหนดออกเดินทางประมาณ",
    name: "departure_date",
    placeholder: "",
    type: "date",
    typeForm: "date",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "period_time_work",
  },

  {
    label: "ข้อมูลค่าตอบแทน",
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "ค่าตอบแทนที่ได้รับ (บาท)",
    name: "thb",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration",
  },
  {
    label: "เงินเดือน อัตราเงินเดือน/ปีละ",
    name: "saraly_rate",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },
  {
    label: "ค่าที่พัก",
    name: "accommodation_costs",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },
  {
    label: "ค่าพาหนะในการเดินทาง",
    name: "transportation_costs",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },
  {
    label: "อื่นๆ",
    name: "other",
    placeholder: "",
    type: "checkbox-input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    radioName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "remuneration_info",
  },
];

export default generateForm06;
